import { useTranslation } from "react-i18next";
import type { DeliveryPriceSuggestion } from "@/types";

interface DeliveryPriceSuggestionsProps {
  suggestions: DeliveryPriceSuggestion[];
  onSelect: (price: number) => void;
}

export function DeliveryPriceSuggestions({
  suggestions,
  onSelect,
}: DeliveryPriceSuggestionsProps) {
  const { t } = useTranslation();

  if (suggestions.length === 0) return null;

  return (
    <div className="mt-2">
      <p className="text-xs font-medium text-gray-600">
        {t("listings.suggested_shipping_prices")}
      </p>
      <p className="mb-1.5 text-xs text-gray-400">
        {t("listings.suggested_shipping_hint")}
      </p>
      <div className="flex flex-wrap gap-1.5">
        {suggestions.map((suggestion) => (
          <button
            key={`${suggestion.carrier}-${suggestion.tier}`}
            type="button"
            onClick={() => onSelect(suggestion.suggestedPrice)}
            className={`inline-flex items-center rounded-full px-2.5 py-1 text-xs font-medium transition-colors ${
              suggestion.recommended
                ? "ring-2 ring-primary-600 bg-primary-50 text-primary-800 hover:bg-primary-100"
                : "bg-gray-100 text-gray-700 hover:bg-gray-200"
            }`}
          >
            {suggestion.carrier} {suggestion.tier} — {suggestion.suggestedPrice.toFixed(2)} €
          </button>
        ))}
      </div>
    </div>
  );
}
